import { BaseService } from './base.service'
import { Uris } from '../common/constants'
import {IEquipment} from '../models/equipment/equipment.model'
import { IMaintenance } from '../models/maintenance/maintenance.model';
import { IMaintenanceSearchParams } from '../store/maintenance/maintenance-state.store';
import { ITemplateMaintenance } from '../models/maintenance/template-maintenance.model';

export interface IMaintenanceService {
  getIntervalTypes: () => Promise<any>;
  getMaintenanceTemplates: (params:any) => Promise<any>;
  getMaintenanceReport: (params:any) => Promise<any>;
  deleteMaintenanceTemplate: (id:string) => Promise<any>;
  getMaintenances: (params: IMaintenanceSearchParams) => Promise<any>;
  getMaintenance: (id: string) => Promise<any>;
  getMaintenanceActions: (id: string) => Promise<any>;
  postMaintenanceAction: (id:string, payload:any) => Promise<any>;
  postMaintenance: (maintenance: IMaintenance) => Promise<any>;
  patchMaintenance: (id: string, maintenance: IMaintenance) => Promise<any>;
  postMaintenanceTemplate: (maintenanceTemplate: ITemplateMaintenance) => Promise<any>;
  patchMaintenanceTemplate: (id: string, maintenanceTemplate: ITemplateMaintenance) => Promise<any>;
  getEquipments: (params: any) => Promise<any>;
  postEquipment: (equipment: IEquipment) => Promise<any>;
  patchEquipment: (id: string, equipment: IEquipment) => Promise<any>;
  getEquipment: (id: string) => Promise<any>;
  getVehicle: (param: any) => Promise<any>;
  getVehicleCost: (param: {equipment:number,category:number,subcategory:number}) => Promise<any>;
  getVehicleFleet: (params: any) => Promise<any>;
  patchEquipmentAttribute: (eid: string, aid: string, params: any) => Promise<any>;
}

export class MaintenanceService extends BaseService implements IMaintenanceService {
  getIntervalTypes (): Promise<any> {
    return super.get(Uris.IntervalType)
  }
  getMaintenanceTemplates (params:any): Promise<any> {
    return super.get(Uris.MaintenanceTemplate,params)
  }
  getMaintenanceReport (params:any): Promise<any> {
    return super.get(Uris.MaintenanceReport,params)
  }
  deleteMaintenanceTemplate(id:string): Promise<any> {
    return super.delete(`${Uris.MaintenanceTemplate}/${id}`)
  }
  getMaintenances (params: IMaintenanceSearchParams): Promise<any> {
    return super.get(Uris.Maintenance, params)
  }
  getMaintenance (id: string): Promise<any> {
    return super.get(Uris.MaintenanceById.replace(':id', id))
  }
  getMaintenanceActions (id: string): Promise<any> {
    return super.get(Uris.MaintenanceByIdActions.replace(':id', id))
  }
  postMaintenanceAction (id: string, payload): Promise<any> {
    return super.post(Uris.MaintenanceByIdActions.replace(':id', id), payload)
  }
  postMaintenance (maintenance: IMaintenance): Promise<any> {
    return super.post(Uris.Maintenance, maintenance)
  }
  patchMaintenance (id: string, maintenance: IMaintenance): Promise<any> {
    return super.patch(Uris.MaintenanceById.replace(':id', id), maintenance)
  }
  postMaintenanceTemplate (maintenanceTemplate: ITemplateMaintenance): Promise<any> {
    return super.post(Uris.MaintenanceTemplate, maintenanceTemplate)
  }
  patchMaintenanceTemplate (id: string, maintenanceTemplate: ITemplateMaintenance): Promise<any> {
    return super.patch(Uris.MaintenanceTemplateById.replace(':id', id), maintenanceTemplate)
  }
  getEquipments (params: any): Promise<any> {
    return super.get(Uris.Equipment, params)
  }
  postEquipment (equipment: IEquipment): Promise<any> {
    return super.post(Uris.Equipment, equipment)
  }
  patchEquipment (id: string, equipment: IEquipment): Promise<any> {
    return super.patch(Uris.EquipmentById.replace(':id', id), equipment)
  }
  getEquipment (id: string): Promise<any> {
    return super.get(Uris.EquipmentById.replace(':id', id))
  }
  getVehicle (id: string): Promise<any> {
    return super.get(Uris.VehicleById.replace(':id', id))
  }
  getVehicleCost (params: {equipment:number,category:number,subcategory:number}): Promise<any> {
    return super.get(Uris.VehicleCost, params)
  }
  getVehicleFleet (params: any): Promise<any> {
    return super.get(Uris.Vehicule, params)
  }
  patchEquipmentAttribute (eid, aid, params): Promise<any> {
    return super.patch(Uris.EquipmentAttributeById
      .replace(':eid', eid)
      .replace(':aid', aid), params)
  }
}



// WEBPACK FOOTER //
// ./src/services/maintenance.service.ts